import { render, staticRenderFns } from "./HomepageStardardDashboardsSettingsDialog.vue?vue&type=template&id=b91ed904"
import script from "./HomepageStardardDashboardsSettingsDialog.vue?vue&type=script&lang=js"
export * from "./HomepageStardardDashboardsSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./HomepageStardardDashboardsSettingsDialog.vue?vue&type=style&index=0&id=b91ed904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports